/* Afroyla LAST PIECES — on-page quick view (no PDP exit). Any [data-alp-quick="<handle>"] (shelf card image,
 * Lightning photo) opens a bottom sheet (desktop ≥900px: centered dialog). Paints instantly from the inline live
 * data (title, material, price, "Only N left" for odd-lot qty ≤ 9), then swaps in the full photo gallery from
 * /products/<h>.js. All products are single-variant, so no picker. Ctrl/⌘/middle click still opens the PDP.
 * Esc / backdrop / × close; focus returns to the opener. Port of the Lettoria Odd Lot sheet (10-16) incl. the brief pair block. */
(function () {
  var A = window.ALP;
  if (!A) return;
  var root = A.root;
  var sheet = root.querySelector('[data-alp-qv]');
  if (!sheet) return;
  var body = sheet.querySelector('[data-alp-qv-body]');
  var opener = null, cur = null, reqId = 0;

  function slide(src, alt, lazy, first) {
    return '<div class="alp-qv__slide' + (first ? ' is-mock' : '') + '" data-qv-zoom data-hc-el="quick-view-zoom"><img src="' + A.esc(A.img(src, 900)) + '" alt="' + A.esc(alt) + '"' + (lazy ? ' loading="lazy"' : '') + ' width="900" height="1200"></div>';
  }
  // brief §4 (in the quick view, which is this page's PDP): bag → "Complete it with a wallet" (≤3 same-design wallets,
  // "$8.95 ~~$12.95~~ with this bag"; no match → first wallets in shelf order); wallet → "Buy 3 wallets, save $7"
  // + 3 other wallets. Rows use data-add (shelf module's add handler). Status line updates after an add.
  function pairBlock(d) {
    var O = window.ALPOffers, isBag = d.g !== 'wallet';
    var inCart = {};
    ((A.cart && A.cart.items) || []).forEach(function (it) { inCart[it.handle] = true; });
    var all = A.data().filter(function (x) { return x.a && x.g === 'wallet' && x.s !== 'odd' && x.h !== d.h && !inCart[x.h]; }); // odd lots live in Lightning only
    var want = isBag && O ? O.matching(d.h) : [];
    var ws = want.map(function (h) { return all.filter(function (x) { return x.h === h; })[0]; }).filter(Boolean);
    all.forEach(function (x) { if (ws.length < 3 && ws.indexOf(x) < 0) ws.push(x); });
    var rows = ws.slice(0, 3).map(function (x) {
      var price = isBag ? '<b>' + A.money(x.p - 4) + '</b> <s>' + A.money(x.p) + '</s> <small>with this bag</small>' : '<b>' + A.money(x.p) + '</b>';
      return '<li><img src="' + A.esc(A.img(x.i, 160)) + '" alt="" width="64" height="52" loading="lazy">' +
        '<span class="alp-pair__t">' + A.esc(x.t) + '<span class="alp-pair__p">' + price + '</span></span>' +
        '<button type="button" class="alp-pair__add" data-add="' + A.esc(x.h) + '" data-hc-el="qv-pair-' + (isBag ? 'bag-wallet' : 'trio') + '">Add</button></li>';
    }).join('');
    return '<div class="alp-pair"><p class="alp-pair__h">' + (isBag ? (want.length ? 'Complete it with a matching wallet' : 'Complete it with a wallet') : 'Buy 3 wallets, save $7') + '</p>' +
      '<p class="alp-pair__s" data-qv-tier>' + (isBag ? 'Every bag unlocks $4 off one wallet. Applied in your cart.' : A.money(d.p - 4) + ' with any bag. Or take 3 wallets and save $7 on your order.') + '</p>' +
      '<ul>' + rows + '</ul></div>';
  }
  function open(handle, from) {
    var d = A.data().filter(function (x) { return x.h === handle; })[0];
    if (!d) { location.href = '/products/' + handle; return; }
    opener = from || null; cur = d;
    var id = ++reqId;
    var off = A.pct(d.p, d.c);
    var left = d.s === 'odd' && d.q != null && d.q > 0;
    body.innerHTML =
      '<div class="alp-qv__gallery" data-qv-gallery>' + slide(d.i, d.t, false, true) + '</div>' +
      '<p class="alp-qv__hint">Tap the photo to zoom</p>' +
      '<div class="alp-qv__info"><h3 class="alp-qv__title" id="alp-qv-title">' + A.esc(d.t) + '</h3>' +
      (d.m ? '<p class="alp-qv__mat">' + A.esc(d.m) + '</p>' : '') +
      '<p class="alp-price alp-price--lg"><b>' + A.money(d.p) + '</b>' + (d.c > d.p ? ' <s>' + A.money(d.c) + '</s>' : '') +
      (off ? ' <span class="alp-qv__off">−' + off + '%</span>' : '') + '</p>' +
      (left ? '<p class="alp-left">Only ' + d.q + ' left</p>' : '') +
      (d.s === 'odd' ? '<p class="alp-final alp-final--qv">Final sale</p>' : '') +
      '<button type="button" class="alp-btn alp-btn--big" data-qv-add data-hc-el="quick-view-add"' + (d.a ? '' : ' disabled') + '>' +
        (d.a ? 'Add to cart · ' + A.money(d.p) : 'Gone — someone took the last one') + '</button>' +
      pairBlock(d) +
      '<a class="alp-qv__pdp" href="/products/' + A.esc(d.h) + '" data-hc-el="quick-view-pdp">Full details →</a></div>';
    sheet.hidden = false;
    document.documentElement.classList.add('alp-qv-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    sheet.querySelector('[data-alp-qv-close]').focus({ preventScroll: true });
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || id !== reqId) return;
        var imgs = (p.images || []).slice(0, 8);
        if (imgs.length > 1) body.querySelector('[data-qv-gallery]').innerHTML = imgs.map(function (src, k) { return slide(src, d.t + ' photo ' + (k + 1), k > 0, k === 0); }).join('');
        if (!p.available && d.a) { A.markGone(d.h); var b = body.querySelector('[data-qv-add]'); b.disabled = true; b.textContent = 'Gone — someone took the last one'; }
      }).catch(function () {});
  }
  function close() {
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('alp-qv-lock');
    reqId++;
    setTimeout(function () { sheet.hidden = true; body.innerHTML = ''; }, 200);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }
  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-alp-qv-close]') || e.target === sheet) { close(); return; }
    var z = e.target.closest('[data-qv-zoom]');
    if (z) { // zoom 2.2× toward the tapped point; tap again to reset
      var im = z.querySelector('img'), r = im.getBoundingClientRect();
      im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      z.classList.toggle('is-zoom');
      return;
    }
    var add = e.target.closest('[data-qv-add]');
    if (add && cur && cur.a) A.runAdd(add, cur);
  });
  // after an add while the sheet is open: the pair block's status line becomes the live offer progress
  root.addEventListener('alp:added', function (e) {
    var t = !sheet.hidden && body.querySelector('[data-qv-tier]');
    if (t && e.detail && e.detail.cart && A.offerStatus) t.innerHTML = A.offerStatus(e.detail.cart);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) close(); });
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-alp-quick]');
    if (!a || e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    open(a.dataset.alpQuick, a);
  });
})();
